import React, { useState } from "react";
import ajaxUser from "../util/remote/ajaxUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
function Login() {
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const [viewpass, setViewpass] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const password = btoa(pass);
    const data = { username, password };
    const server_response = await ajaxUser.loginUser(data);
    if (server_response.status === "OK") {
      localStorage.setItem("la_procure@user", server_response.details);
      localStorage.setItem("loginTime", new Date().getTime().toString());
      navigate("/");
      window.location.reload();
      toast.success(server_response.message);
    } else {
      toast.error(server_response.message);
    }
  };
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${process.env.PUBLIC_URL}/farmwise_login_background.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Poppins, sans-serif",
        color: "white",
      }}
    >
      <div
        className="card shadow-lg border-0"
        style={{
          background: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(12px)",
          borderRadius: "15px",
          maxWidth: "900px",
          width: "100%",
        }}
      >
        <Toaster />
        <div className="row g-0">
          {/* Left side (logo and intro) */}
          <div className="col-lg-5 d-none d-lg-flex align-items-center justify-content-center p-4">
            <div className="text-center">
              <img
                src={process.env.PUBLIC_URL + "/farmwise_logo.png"}
                alt="Logo"
                style={{ maxWidth: "200px" }}
              />
              <p className="text-white mt-4">
                Sign in to create, discover, and make life better
              </p>
            </div>
          </div>
          {/* Right side (form) */}
          <div className="col-lg-7 p-5">
            <form onSubmit={handleSubmit}>
              <h2 className="text-white mb-4">Account Login</h2>
              <div className="mb-4">
                <label className="form-label text-white fs-5">Username</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label text-white fs-5">Password</label>
                <div className="position-relative">
                  <input
                    type={viewpass ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter your password"
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                    required
                  />
                  <i
                    className={`fa ${viewpass ? "fa-eye-slash" : "fa-eye"}`}
                    onClick={() => setViewpass(!viewpass)}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#ccc",
                      fontSize: "1.2rem",
                    }}
                  />
                </div>
              </div>
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg rounded-pill"
                >
                  Sign In
                </button>
              </div>
              <div className="mt-4 text-white text-start">
                <a href="/password_rest/forgot" className="text-info">
                  Forgot password?
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
